export const DEL_ENTITIES = 'DEL_ENTITIES';
